// ./application-steps/index.js
import React from 'react';

import StepContent1 from "./StepContent1";
import StepContent2 from "./StepContent2";
import StepContent3 from "./StepContent3";
import StepContent4 from "./StepContent4";
import StepContent5 from "./StepContent5";
import StepContent6 from "./StepContent6";
import StepContent7 from "./StepContent7";
import StepContent8 from "./StepContent8";
import StepContent9 from "./StepContent9";

const getSteps = () => [
  {
    label: "Step 1: Personal Information",
    content: <StepContent1 />,
  },
  {
    label: "Step 2: Academic Information",
    content: <StepContent2 />,
  },
  {
    label: "Step 3: Award Selection",
    content: <StepContent3 />,
  },
  {
    label: "Step 4: School Activities Documentation",
    content: <StepContent4 />,
  },
  {
    label: "Step 5: Community Activities Documentation",
    content: <StepContent5 />,
  },
  {
    label: "Step 6: Background & Goals",
    content: <StepContent6 />,
  },
  {
    label: "Step 7: Affiliations",
    content: <StepContent7 />,
  },
  {
    label: "Step 8: Bursary Declaration",
    content: <StepContent8 />,
  },
  {
    label: "Step 9: Review & Submit",
    content: <StepContent9 />,
  },
];

export { getSteps };
